import { SdkConfig } from '@criptalia/sdk/src/Sdk'

const wsProtocol = import.meta.env.VITE_API_URL.search(/^https:/) > -1 ? 'wss://' : 'ws://'

const websocketUrl = wsProtocol + import.meta.env.VITE_API_DOMAIN + '/connection/websocket'

const isProduction = window.location.host.endsWith('ensocoliving.com')
export const FRONTEND_ENV: SdkConfig['env'] = {
  isProduction,
  isProductionBuild: import.meta.env.PROD,
  websocketUrl,
  brandName: 'Enso Coliving',
  datocmsToken:
    import.meta.env.VITE_DATO_CMS_TOKEN || '36f706f8f7d30863b20b5df673a34e',
  mapsApiKey:
    import.meta.env.VITE_MAPS_API_KEY ||
    'AIzaSyB15ds5CBvNKu8VGdxMxKp7nVPPLYtqQkM',    
}
